<ng-select [items]="items" [(ngModel)]="model" placeholder="{{placeHolderText}}" [disabled]="disableInput"
    (change)="statusChanged.emit(model)"
    class="cursorPointer dropdown form-control search bg-light pt-0 border-light pb-0 flex-grow-1" [searchable]="false"
    [clearable]="false">

    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span *ngIf="item.selectedText" class="ng-value-label " [ngClass]="{'text-muted': item.default==true}">
            <span *ngIf="(item.selectedText !== undefined) else elseValueText">
                {{item.selectedText}}
            </span>
            <ng-template #elseValueText>
                {{item.value}}
            </ng-template>
        </span>
    </ng-template>

    <ng-template ng-option-tmp class="border-light" let-item="item" let-clear="clear" >
     
            <span class="ng-value-label" [ngClass]="{'text-muted': item.default==true}">
                <span *ngIf="(item.dropdownText !== undefined) else elseSelectedText">
                    {{item.dropdownText}}
                </span>
                <ng-template #elseSelectedText>
                    <span *ngIf="(item.selectedText  !== undefined) else elseValueText">
                        {{item.selectedText}}
                    </span>
                </ng-template>
                <ng-template #elseValueText>
                    {{item.value}}
                </ng-template>
            </span>
   
    </ng-template>
</ng-select>